import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "./SharedStyles/reset.css";

ReactDOM.render(<App />,document.getElementById('root'));